import HttpRequest from "../HttpRequest";

const userService = () => {
    const {post} = HttpRequest()
    const createUser = (input) => {
        return post('user/register',input)
    }

    const updateUser = (input) => {
        return post(`user/update/${input.uuid}`,input)
    }

    const getUser = () => {
        return post('user/user')
    }

    const listUsers = (variables) => {
        return post('user/list',variables)
    }

    return {
        createUser,
        updateUser,
        getUser,
        listUsers,
    }
}

export default userService